var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router, ActivatedRoute } from '@angular/router';
var CustomerEditComponent = /** @class */ (function () {
    function CustomerEditComponent(util, apiService, router, activatedRoute) {
        this.util = util;
        this.apiService = apiService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.isExistingUser = false;
        this.token = "";
        this.submitted = false;
    }
    //username = ""
    //userId=""
    //newPass = ""
    //confirmPass = ""
    //oldPassword = "";
    //isResetSuccess = false
    //tmpUsername = ""
    //tmpNewPass = ""
    CustomerEditComponent.prototype.ngOnInit = function () {
        //let cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
        //this.username = cookieData["username"]
        //this.userId = cookieData["userId"]
        var _this = this;
        this.activatedRoute.queryParams.subscribe(function (params) {
            _this.token = params['id'];
        });
        if (this.token == null || this.token.toString().trim().length == 0) {
            this.util.ErrorDialog("ไม่พบข้อมูลการขอแก้ไข กรุณาลองใหม่อีกครั้ง");
        }
        else {
            this.validateToken();
        }
    };
    CustomerEditComponent.prototype.validateToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var req, res, req_1, resS;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.util.ShowWaiting(true);
                        req = {
                            token_id: this.token
                        };
                        console.log(this.token);
                        return [4 /*yield*/, this.apiService.get("crmservice", "contactLogSave", "token=" + this.token)];
                    case 1:
                        res = _a.sent();
                        if (!(this.util.isSuccessResponse(res) && res.RESMSG == "SUCCESS")) return [3 /*break*/, 3];
                        req_1 = {
                            email: res.email,
                            call_by: "1",
                            url: this.util.baseUrl(),
                            firstname: res.conName,
                            lastname: res.conLastName,
                            userid: res.userId
                        };
                        return [4 /*yield*/, this.apiService.postCustom("Crm", "SendMailSuccess", req_1)];
                    case 2:
                        resS = _a.sent();
                        this.token = res.token_id;
                        $('#txtAnnount')[0].innerHTML = 'แก้ไขข้อมูลสำเร็จ';
                        this.util.ShowWaiting(false);
                        this.util.SuccessDialog("แก้ไขข้อมูลสำเร็จ");
                        return [3 /*break*/, 4];
                    case 3:
                        $('#txtAnnount')[0].innerHTML = 'แก้ไขข้อมูลไม่สำเร็จ';
                        this.util.ShowWaiting(false);
                        this.util.ErrorDialog("ไม่พบข้อมูลการขอแก้ไข กรุณาลองใหม่อีกครั้ง");
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CustomerEditComponent.prototype.close = function () {
        window.close();
    };
    return CustomerEditComponent;
}());
export { CustomerEditComponent };



// WEBPACK FOOTER //
// ./src/app/customerEdit/customerEdit.component.ts.pre-build-optimizer.js